import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from "ngx-toastr";
import { fadeInUp400ms } from '../../../../../@vex/animations/fade-in-up.animation';
import { AuthService } from './service/auth.service';
import { CookieHandler } from 'src/shared/classes/cookie.class';
import { NavigationService } from 'src/@vex/services/navigation.service';
@Component({
  selector: 'vex-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInUp400ms
  ]
})
export class LoginComponent implements OnInit {
  form: UntypedFormGroup;
  form1: UntypedFormGroup;
  serverCode: string = '';
  countdown: number = 60;
  private tempToken: string;
  timer: any;
  canResend: boolean = false;
  loading: boolean = false;
  inputType = 'password';
  visible = false;
Vislogin: boolean=true
VisCod: boolean=false;
  constructor(private router: Router,  private navigationService: NavigationService ,
              private fb: UntypedFormBuilder,
              private cd: ChangeDetectorRef,
              private toaster:ToastrService,
              private readonly _testSrv: AuthService,
  ) {}
  ngOnInit() {
    this.form = this.fb.group({
      phoneNumber: ['', Validators.required],
    });
    this.form1=this.fb.group({
      d1: ['', [Validators.required, Validators.pattern('[0-9]')]],
      d2: ['', [Validators.required, Validators.pattern('[0-9]')]],
      d3: ['', [Validators.required, Validators.pattern('[0-9]')]],
      d4: ['', [Validators.required, Validators.pattern('[0-9]')]],
    });;
  }
  moveNext(event: any, nextControl: string) {
    if (event.target.value.length === 1) {
      const next = document.querySelector(`input[formcontrolname="${nextControl}"]`) as HTMLElement;
      if (next) next.focus();
    }
  }
  verifyCode() {
    if (this.form1.invalid) {
      this.toaster.error('کد را کامل وارد کنید');
      return;
    }
    const enteredCode =
      this.form1.value.d1 +
      this.form1.value.d2 +
      this.form1.value.d3 +
      this.form1.value.d4;
     if (enteredCode === this.serverCode) {
    CookieHandler.setToken(this.tempToken);
    this.loginUser();
    } else {
      this.toaster.error('کد وارد شده صحیح نیست');
    }
  }
  allowOnlyNumbers(event: any) {
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
    this.form.get('phoneNumber')?.setValue(event.target.value, { emitEvent: false });
  }
  
  send() {
    if (this.form.invalid) {
      this.toaster.error('شماره همراه را وارد کنید');
      return;
    }
    this.loading = true;
    this.cd.markForCheck();
    this._testSrv.SendCodeAdmin(this.form.value.phoneNumber).subscribe((res: any) => {
        this.loading = false;
        const responseCode = res?.response?.code;
        if (responseCode === -1) {
          this.toaster.warning('شماره موبایل در سیستم ثبت نشده است');
          this.cd.markForCheck();
          return;
        }
        if (responseCode === -2) {
          this.toaster.error('ارسال پیامک با خطا مواجه شد');
          this.cd.markForCheck();
          return;
        }
        if (res?.response?.token) {
          
          this.tempToken = res.response.token;
          this.serverCode = String(Number(res.response.code) - 1380);
          this.VisCod = true;
          this.Vislogin = false;
          this.startTimer();
          this.toaster.success('کد تایید ارسال شد');
          this.cd.markForCheck();
        }
      }, () => {
        this.loading = false;
        this.toaster.error('خطای سرور');
        this.cd.markForCheck();
      });
  }
  editPhone() {
    this.VisCod = false;
    this.Vislogin=true
  }
  loginUser() {
    this.loading = true;
    this._testSrv.SinginAdmin().subscribe({
      next: (res: any) => {
    const menuData = res?.response?.token?.menu;

    this._testSrv.setMenu(menuData);

    this.navigationService.items =
    this._testSrv.buildNavigation(menuData);
        this.router.navigate(['/dashboards/analytics']);
        this.loading = false;
        this.cd.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.toaster.error('خطای سرور');
        this.cd.markForCheck();
      }
    });
  }
  startTimer() {
    this.countdown = 60;
    this.canResend = false;
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(this.timer);
        this.canResend = true;
      }
      this.cd.markForCheck();
    }, 1000);
  }
  resendCode() {
    if (!this.canResend) return;
    this.send();
  }
  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  Back() {
      this.VisCod=false
      this.Vislogin=true
  }
  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
      this.cd.markForCheck();
    } else {
      this.inputType = 'text';
      this.visible = true;
      this.cd.markForCheck();
    }
  }
}